import { Component } from '@angular/core';

@Component({
    selector: 'wci-location',
    imports: [],
    templateUrl: './location.component.html',
    styles: ``,
})
export class LocationComponent {}
